import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, query, where, onSnapshot, deleteDoc, doc, updateDoc } from "firebase/firestore";
import Seite from "../components/Seite";

const leerKontakt = { name: "", funktion: "", firma: "", email: "", telefon: "", notizen: "" };

export default function Kontakt({ user }) {
  const [kontakte, setKontakte] = useState([]);
  const [formular, setFormular] = useState(leerKontakt);
  const [offen, setOffen] = useState(false);
  const [suche, setSuche] = useState("");
  const [editId, setEditId] = useState(null);
  const [editDaten, setEditDaten] = useState(leerKontakt);

  useEffect(() => {
    const q = query(collection(db, "kontakte"), where("uid", "==", user.uid));
    return onSnapshot(q, (snap) => setKontakte(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
  }, [user.uid]);

  const speichern = async (e) => {
    e.preventDefault();
    if (!formular.name.trim()) return;
    await addDoc(collection(db, "kontakte"), { ...formular, uid: user.uid, erstellt: new Date() });
    setFormular(leerKontakt);
    setOffen(false);
  };

  const editSpeichern = async (id) => {
    await updateDoc(doc(db, "kontakte", id), editDaten);
    setEditId(null);
  };

  const gefiltert = kontakte.filter((k) =>
    k.name?.toLowerCase().includes(suche.toLowerCase()) ||
    k.firma?.toLowerCase().includes(suche.toLowerCase()) ||
    k.funktion?.toLowerCase().includes(suche.toLowerCase())
  );

  return (
    <Seite titel="Kontakte">
      <div style={styles.toolbar}>
        <input style={styles.suche} placeholder="Suchen..." value={suche} onChange={(e) => setSuche(e.target.value)} />
        <button style={styles.button} onClick={() => setOffen(!offen)}>{offen ? "Abbrechen" : "+ Neuer Kontakt"}</button>
      </div>

      {offen && (
        <form onSubmit={speichern} style={styles.formular}>
          <div style={styles.zeile}>
            <input style={styles.input} placeholder="Name *" value={formular.name} onChange={(e) => setFormular({ ...formular, name: e.target.value })} required />
            <input style={styles.input} placeholder="Funktion / Titel" value={formular.funktion} onChange={(e) => setFormular({ ...formular, funktion: e.target.value })} />
          </div>
          <input style={styles.input} placeholder="Firma" value={formular.firma} onChange={(e) => setFormular({ ...formular, firma: e.target.value })} />
          <div style={styles.zeile}>
            <input style={styles.input} placeholder="E-Mail" value={formular.email} onChange={(e) => setFormular({ ...formular, email: e.target.value })} />
            <input style={styles.input} placeholder="Telefon" value={formular.telefon} onChange={(e) => setFormular({ ...formular, telefon: e.target.value })} />
          </div>
          <textarea style={styles.textarea} placeholder="Notizen" value={formular.notizen} onChange={(e) => setFormular({ ...formular, notizen: e.target.value })} rows={3} />
          <button style={styles.button} type="submit">Speichern</button>
        </form>
      )}

      {gefiltert.length === 0 && !offen && <p style={styles.leer}>Keine Kontakte gefunden.</p>}
      {gefiltert.map((k) => (
        <div key={k.id} style={styles.karte}>
          {editId === k.id ? (
            <div style={styles.formular}>
              <div style={styles.zeile}>
                <input style={styles.input} placeholder="Name *" value={editDaten.name} onChange={(e) => setEditDaten({ ...editDaten, name: e.target.value })} />
                <input style={styles.input} placeholder="Funktion / Titel" value={editDaten.funktion} onChange={(e) => setEditDaten({ ...editDaten, funktion: e.target.value })} />
              </div>
              <input style={styles.input} placeholder="Firma" value={editDaten.firma} onChange={(e) => setEditDaten({ ...editDaten, firma: e.target.value })} />
              <div style={styles.zeile}>
                <input style={styles.input} placeholder="E-Mail" value={editDaten.email} onChange={(e) => setEditDaten({ ...editDaten, email: e.target.value })} />
                <input style={styles.input} placeholder="Telefon" value={editDaten.telefon} onChange={(e) => setEditDaten({ ...editDaten, telefon: e.target.value })} />
              </div>
              <textarea style={styles.textarea} placeholder="Notizen" value={editDaten.notizen} onChange={(e) => setEditDaten({ ...editDaten, notizen: e.target.value })} rows={3} />
              <div style={styles.zeile}>
                <button style={styles.button} onClick={() => editSpeichern(k.id)}>💾 Speichern</button>
                <button style={{ ...styles.button, backgroundColor: "#999" }} onClick={() => setEditId(null)}>Abbrechen</button>
              </div>
            </div>
          ) : (
            <>
              <div style={styles.karteHeader}>
                <div>
                  <strong>{k.name}</strong>
                  {k.funktion && <span style={styles.funktion}> · {k.funktion}</span>}
                  {k.firma && <span style={styles.firma}> · {k.firma}</span>}
                </div>
                <div>
                  <button style={styles.iconBtn} onClick={() => { setEditId(k.id); setEditDaten({ name: k.name || "", funktion: k.funktion || "", firma: k.firma || "", email: k.email || "", telefon: k.telefon || "", notizen: k.notizen || "" }); }}>✏️</button>
                  <button style={styles.iconBtn} onClick={() => deleteDoc(doc(db, "kontakte", k.id))}>🗑️</button>
                </div>
              </div>
              {k.email && <p style={styles.info}>✉️ <a href={`mailto:${k.email}`}>{k.email}</a></p>}
              {k.telefon && <p style={styles.info}>📞 {k.telefon}</p>}
              {k.notizen && <p style={styles.info}>📝 {k.notizen}</p>}
            </>
          )}
        </div>
      ))}
    </Seite>
  );
}

const styles = {
  toolbar: { display: "flex", gap: "0.5rem", marginBottom: "1rem" },
  suche: { flex: 1, padding: "0.6rem", fontSize: "1rem", border: "1px solid #ccc", borderRadius: "4px" },
  button: { padding: "0.6rem 1rem", backgroundColor: "#1a73e8", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" },
  formular: { backgroundColor: "#f8f9fa", padding: "1rem", borderRadius: "6px", marginBottom: "1rem", display: "flex", flexDirection: "column", gap: "0.6rem" },
  zeile: { display: "flex", gap: "0.6rem" },
  input: { flex: 1, padding: "0.6rem", fontSize: "0.95rem", border: "1px solid #ccc", borderRadius: "4px" },
  textarea: { padding: "0.6rem", fontSize: "0.95rem", border: "1px solid #ccc", borderRadius: "4px", resize: "vertical" },
  karte: { backgroundColor: "white", borderRadius: "6px", padding: "1rem", marginBottom: "0.8rem", boxShadow: "0 1px 3px rgba(0,0,0,0.1)" },
  karteHeader: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.3rem" },
  funktion: { color: "#1a73e8", fontWeight: "normal" },
  firma: { color: "#666", fontWeight: "normal" },
  info: { margin: "0.2rem 0", color: "#444", fontSize: "0.9rem" },
  iconBtn: { background: "none", border: "none", cursor: "pointer", fontSize: "1rem" },
  leer: { color: "#999", textAlign: "center" },
};
